import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";

export const StudentPipelineRoutes: Route[] = [
  {
    path: "student-pipeline",
    loadComponent: () =>
      import("../../Feature/student-pipeline/pages/pipeline/student-pipeline.component").then(
        (mod) => mod.StudentPipelineComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
